// src/config/templates.js

export const ESTABELECIMENTO_TEMPLATES = {
    pizzaria: {
        id: 'pizzaria',
        label: 'Pizzaria',
        banner: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?q=80&w=1000',
        color: '#ea1d2c'
    },
    hamburgueria: {
        id: 'hamburgueria',
        label: 'Hamburgueria',
        banner: 'https://images.unsplash.com/photo-1550547660-d9450f859349?q=80&w=1000',
        color: '#ffc107'
    },
    japonesa: {
        id: 'japonesa',
        label: 'Comida Japonesa',
        banner: 'https://images.unsplash.com/photo-1579871494447-9811cf80d66c?q=80&w=1000',
        color: '#000000'
    },
    acai: {
        id: 'acai',
        label: 'Açaí & Sorvetes',
        banner: 'https://images.unsplash.com/photo-1590301157890-4810ed352733?q=80&w=1000',
        color: '#6b21a8'
    },
    padaria: {
        id: 'padaria',
        label: 'Padaria & Confeitaria',
        banner: 'https://images.unsplash.com/photo-1509440159596-0249088772ff?q=80&w=1000',
        color: '#d97706'
    },
    restaurante: {
        id: 'restaurante',
        label: 'Restaurante Geral',
        banner: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?q=80&w=1000',
        color: '#ea1d2c'
    }
};

export const getBannerByType = (type) => {
    return ESTABELECIMENTO_TEMPLATES[type]?.banner || ESTABELECIMENTO_TEMPLATES.restaurante.banner;
};